module.exports = __webpack_public_path__ + "static/media/GamesWizards01_1.ae42db3e.png";